export default __webpack_public_path__ + "fc62f11483608e6af7b8d44bddf8d412.png";